import * as positions from './positions';
import * as squads from './squads';
import * as team from './team';

export default {
	positions,
	squads,
	team,
};


// WEBPACK FOOTER //
// ./src/modules/selectors/complex/index.js